import { makeStyles } from '~/UIKit/Style';
import React, { memo, useState } from 'react';
import { FitoListReactQuery } from '~/Components';
import { useLanguage } from '~/Hooks';
import { PrivateLayout } from '~/Layout/PrivateLayout';
import { IPayouts } from '~/Models/DTO/Payouts.model';
import { useRequestPayoutsList } from '~/requests/uscProxyService/useRequestPayoutsList';
import { MonthRangePicker } from './components';
import { usePayouts } from './usePayouts';
import YogaImg from '~/Assets/Images/SportsIllustrations/Yoga.svg';

const useStyles = makeStyles(() => ({
  wrapper: {
    margin: '1rem 16px',
    display: 'grid',
  },
}));

export const Payouts = memo(() => {
  const { t } = useLanguage();
  const { classes } = useStyles();
  const { keyOfId, setItemValues, settings, tableDefinition } = usePayouts();

  const defaultQuery = {
    page: 0,
    pageSize: 10,
  };
  const defaultDate = new Date();
  const [dateFilter, setQuery] = useState({
    start: new Date(defaultDate.getFullYear(), defaultDate.getMonth() - 2, 1),
    end: new Date(defaultDate.getFullYear(), defaultDate.getMonth() + 1, 0),
  });

  return (
    <PrivateLayout title={t('app.payouts.header')} hideBackButton>
      <div className={classes.wrapper}>
        <MonthRangePicker
          onChange={setQuery}
          startDate={dateFilter?.start}
          endDate={dateFilter?.end}
        />
      </div>
      <FitoListReactQuery<IPayouts>
        title={t('app.payouts.list')}
        keyOfId={keyOfId}
        settings={settings}
        setItemValues={setItemValues}
        tableDefinition={tableDefinition}
        queryResults={useRequestPayoutsList}
        defaultQuery={defaultQuery}
        appliedFilters={dateFilter}
        placeholder={{
          imgSrc: YogaImg,
          imgAlt: t('app.payouts.emptyState'),
          title: t('app.payouts.emptyState'),
        }}
      />
    </PrivateLayout>
  );
});

export default Payouts;
